import { jsxs, jsx } from "react/jsx-runtime";
import { Flex, FeatureShield24, Text } from "@betterment/style-closet-react";
const SecureInfoBadge = () => {
  return /* @__PURE__ */ jsxs(Flex, { alignItems: "center", children: [
    /* @__PURE__ */ jsx(Flex, { mr: "1", children: /* @__PURE__ */ jsx(FeatureShield24, { color: "bmtGrey50" }) }),
    /* @__PURE__ */ jsx(Text, { as: "p", fontSize: "1", color: "bmtGrey50", m: "0", children: "All your information is secure." })
  ] });
};
export {
  SecureInfoBadge as S
};
//# sourceMappingURL=SecureInfoBadge-DjTZpTAN.js.map
